// extracted by mini-css-extract-plugin
export default {"searchInput":"ASLVideoHistory_searchInput__DwrJL","searchContainer":"ASLVideoHistory_searchContainer__wrg6a"};